import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Checkbox, Col, Form, Icon, Input, message, Row } from 'antd';
import md5 from 'blueimp-md5';
import localDb from '@util/localDb';
import { setUser } from '@store/modules/user';
import { getMenu } from '@store/modules/menu';
import { queryLogin } from '@api';
import Banner from '../assets/img/login_banner.png';
import Pic from '../assets/img/login_pic.png';

import '../assets/less/login.less';

const FormItem = Form.Item;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  submit = e => {
    e.preventDefault();
    const user = this.props.form.getFieldsValue();
    this.props.form.validateFields(err => {
      if (!err) {
        user.password = md5(user.password);
        this.httpLogin(user);
      }
    });
  };

  httpLogin = user => {
    const { router, dispatch } = this.props;
    queryLogin(user).then(res => {
      if (res.statusCode === 200) {
        message.success('欢迎登陆！');
        localDb.set('token', res.data.token);
        dispatch(setUser());
        dispatch(getMenu());
        router.push('/');
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="login_main">
        <div className="login_blue" />
        <div className="login_center">
          <img className="login_top" src={Banner} alt={Banner} width={250} />
          <div className="login_box">
            <Row type="flex" align="middle">
              <Col span={14}>
                <img src={Pic} alt={Pic} />
              </Col>
              <Col span={10}>
                <Card title="用户登录" bordered={false}>
                  <Form onSubmit={this.submit}>
                    <FormItem>
                      {getFieldDecorator('account', {
                        rules: [{ required: true, message: '请输入您的用户名!' }],
                      })(<Input prefix={<Icon type="user" />} placeholder="用户名" />)}
                    </FormItem>
                    <FormItem>
                      {getFieldDecorator('password', {
                        rules: [{ required: true, message: '请输入您的密码!' }],
                      })(
                        <Input prefix={<Icon type="lock" />} type="password" placeholder="密码" />,
                      )}
                    </FormItem>
                    <FormItem>
                      {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true,
                      })(<Checkbox>记住我</Checkbox>)}
                    </FormItem>
                    <FormItem>
                      <Button style={{ width: '100%' }} type="primary" htmlType="submit">
                        登录
                      </Button>
                    </FormItem>
                  </Form>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(Form.create()(Login));



// WEBPACK FOOTER //
// ./src/components/Login.js